import { Table, Collapse, Button } from 'antd';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import hocFrom from 'components/forms/HocFrom';
import InputDate from 'components/inputs/InputDate';
import DashboardContext from 'Context';
import toaster from 'helper/toaster';

const OrderReport = () => {
  const { urldashboard, authentication, handelerrors } =
    useContext(DashboardContext);
  const [data, setDataFech] = useState([]);
  const [loading, setLoading] = useState(true);
  const [excelLoading, setExcelLoading] = useState(false);
  const [customerNameSearch, setCustomerNameSearch] = useState('');
  const [fromDate, setFromDate] = useState(undefined);
  const [toDate, setToDate] = useState(undefined);
  const [jobDispatchPercentage, setJobDispatchPercentage] = useState(0);
  const [manualPercentage, setManualPercentage] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
  });

  useEffect(() => {
    datafeching({
      page: 1,
      pageSize: 20,
      serachCustomer: customerNameSearch,
      fromDate: undefined,
      toDate: undefined,
    });
    jobDispatchVsManualPercentageDataFetch({
      fromDate: undefined,
      toDate: undefined,
    });
    return () => {};
  }, []);

  const handelValueFromDate = (_, value) => {
    setFromDate(value);
  };

  const handelValueToDate = (_, value) => {
    setToDate(value);
  };

  const jobDispatchVsManualPercentageDataFetch = async ({
    fromDate,
    toDate,
  }) => {
    try {
      let url =
        fromDate && toDate
          ? `/orderReport/getPercentageJobDispatchVsManual?fromDate=${fromDate}&toDate=${toDate}`
          : '/orderReport/getPercentageJobDispatchVsManual';

      const res = await Axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });

      const data = await res.data;

      setJobDispatchPercentage(data.jobDispatchPercentage);
      setManualPercentage(data.manualPercentage);
    } catch (error) {
      toaster.error('خطا در محاسبه درصد پخش خودکار نسبت به دستی');
    }
  };

  const datafeching = async ({
    page,
    pageSize,
    serachCustomer,
    fromDate,
    toDate,
  }) => {
    setLoading(true);
    try {
      let url = '/orderReport/get';
      const res = await Axios.post(
        urldashboard + url,
        JSON.stringify({ page, pageSize, serachCustomer, fromDate, toDate }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      setDataFech(data.data);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      handelerrors(error);
      setLoading(false);
    }
  };

  const getExcelReport = async ({
    page,
    pageSize,
    serachCustomer,
    fromDate,
    toDate,
  }) => {
    setExcelLoading(true);

    try {
      let url = '/orderReport/getExcel';

      const res = await Axios.post(
        urldashboard + url,
        JSON.stringify({ page, pageSize, serachCustomer, fromDate, toDate }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
          responseType: 'arraybuffer',
        }
      );

      let blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'OrderReport.xlsx';
      link.click();

      setExcelLoading(false);
    } catch (error) {
      setExcelLoading(false);
    }
  };

  const handleTableChange = (newPagination, filters, sorter) => {
    datafeching({
      page: newPagination.current,
      pageSize: newPagination.pageSize,
      serachCustomer: customerNameSearch,
      fromDate: fromDate,
      toDate: toDate,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      width: '3%',
      render: (item, record, index) => (
        <> {index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'تاریخ شروع',
      dataIndex: 'persianOrderDate',
      key: 'persianOrderDate',
      width: '3%',
    },
    {
      title: 'نام مشتری',
      dataIndex: 'customerName',
      key: 'customerName',
      width: '12%',
    },
    {
      title: 'عنوان سفارش',
      dataIndex: 'orderName',
      key: 'orderName',
      width: '12%',
    },
    {
      title: 'شیفت',
      dataIndex: 'dailyType',
      key: 'dailyType',
      width: '3%',
    },
    {
      title: 'تعداد نیروهای مورد نیاز',
      dataIndex: 'numberOfWorkers',
      key: 'numberOfWorkers',
      width: '7%',
    },
    {
      title: 'تعداد نیروهای اختصاص یافته',
      dataIndex: 'numberOfSetWorkers',
      key: 'numberOfSetWorkers',
      width: '9%',
    },
    {
      title: 'تعداد کمبود نیرو',
      dataIndex: 'numberOfNeededWorkers',
      key: 'numberOfNeededWorkers',
      width: '7%',
    },
    {
      title: 'پذیرفته ها',
      dataIndex: 'numberOfAcceptedWorkers',
      key: 'numberOfAcceptedWorkers',
      width: '7%',
    },
    {
      title: 'ردکرده ها',
      dataIndex: 'numberOfRejectedWorkers',
      key: 'numberOfRejectedWorkers',
      width: '10%',
    },
    {
      title: 'پاسخ نداده ها',
      dataIndex: 'numberOfNoAnswerWorkers',
      key: 'numberOfNoAnswerWorkers',
      width: '10%',
    },
    {
      title: 'در انتظار پاسخ',
      dataIndex: 'numberOfWaitingWorkers',
      key: 'numberOfWaitingWorkers',
      width: '10%',
    },
  ];

  const customerSerach = (event) => {
    setCustomerNameSearch(event.target.value);
  };

  const search = () => {
    datafeching({
      page: 1,
      pageSize: 20,
      serachCustomer: customerNameSearch,
      fromDate: fromDate,
      toDate: toDate,
    });
    jobDispatchVsManualPercentageDataFetch({
      fromDate: fromDate,
      toDate: toDate,
    });
  };

  const getExcel = () => {
    getExcelReport({
      page: pagination.page,
      pageSize: pagination.pageSize,
      serachCustomer: customerNameSearch,
      fromDate: fromDate,
      toDate: toDate,
    });
  };

  const { Panel } = Collapse;

  const reset = () => {
    setFromDate(undefined);
    setToDate(undefined);
    setCustomerNameSearch('');
    datafeching({
      page: 1,
      pageSize: 20,
      serachCustomer: '',
      fromDate: undefined,
      toDate: undefined,
    });
    jobDispatchVsManualPercentageDataFetch({
      fromDate: undefined,
      toDate: undefined,
    });
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div
          style={{
            display: 'flex',
            color: 'white',
            flex: `${jobDispatchPercentage}%`,
            backgroundColor: 'green',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          پخش خودکار {jobDispatchPercentage}%
        </div>
        <div
          style={{
            marginLeft: 10,
            display: 'flex',
            color: 'white',
            flex: `${manualPercentage}%`,
            backgroundColor: 'red',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          دستی {manualPercentage}%
        </div>
        {excelLoading ? (
          <i className='fas fa-sync fa-spin'>
            <i
              style={{ fontSize: '40px', color: 'red' }}
              className='fa fa-file-excel-o'
              aria-hidden='true'
            ></i>
          </i>
        ) : (
          <i
            style={{ fontSize: '40px', color: 'red' }}
            onClick={() => getExcel()}
            className='fa fa-file-excel-o'
            aria-hidden='true'
          ></i>
        )}
      </div>
      <Collapse style={{ marginTop: 15 }} defaultActiveKey={['0']}>
        <Panel header='جستجو' key='1'>
          <div style={{ display: 'flex' }}>
            <div className='col-md-6'>
              <InputDate
                label='از تاریخ'
                name='fromDate'
                defaultValue={fromDate}
                handelValue={handelValueFromDate}
              />
            </div>
            <div className='col-md-6'>
              <InputDate
                label='تا تاریخ'
                name='toDate'
                defaultValue={toDate}
                handelValue={handelValueToDate}
              />
            </div>
          </div>

          <input
            className='form-control'
            value={customerNameSearch}
            onChange={customerSerach}
            type='text'
            placeholder='جستجوی مشتری'
          ></input>

          <div className='row' style={{ display: 'flex', marginTop: 20 }}>
            <div className='col-md-6'>
              <Button
                type='primary'
                style={{ width: '100%' }}
                loading={loading}
                onClick={() => search()}
              >
                جستجو
              </Button>
            </div>
            <div className='col-md-6'>
              <Button
                type='primary'
                danger
                ghost
                style={{ width: '100%' }}
                onClick={() => reset()}
              >
                پاک کردن فرم جستجو
              </Button>
            </div>
          </div>
        </Panel>
      </Collapse>

      <Table
        size='small'
        rowClassName={(row) =>
          row.numberOfNeededWorkers === 0 ? 'backcolor-green center' : 'center'
        }
        style={{ marginTop: 20 }}
        columns={columns}
        bordered={true}
        dataSource={data}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
      />
    </>
  );
};

export default hocFrom(OrderReport);
